import jwtDecode from 'jwt-decode';

import container from '@/plugins/services';
import { AuthService } from '@/data/services/auth.service';

const aclChecker = (val: string | string[], or: boolean = false): boolean => {
	if (!val || Array.isArray(val) && val.length === 0) return true;
	const authService = container.get<AuthService>('AuthService');
	const token = authService.getToken();
	if (!token) return false;
	const dToken = jwtDecode(token);
	const roles = JSON.parse(dToken.user).roles;
	const features = [...dToken.features, ...roles.map((r: any) => `role.${r.role}`)];
	if (Array.isArray(val)) {
		return or ?
			(val as string[]).some(v => features.indexOf(v) >= 0) :
			(val as string[]).every(v => features.indexOf(v) >= 0);
	}
	return features.indexOf(val as string) >= 0;
};

export {
	aclChecker
};